import { useTranslate } from "@tolgee/react";
import { useAtom } from "jotai";
import { triggerPriceAtom } from "./stores/order-form-atoms.ts";
import { sanitizeNumericInput } from "./utils/sanitize-numeric-input.ts";

const PRICE_MAX_DECIMALS = 8;

const fieldClass =
	"flex items-center gap-1.5 rounded-[8px] border border-trade-border-subtle bg-trade-surface-inset px-2.5 py-1.5 sm:gap-2 sm:rounded-[10px] sm:px-3.5 sm:py-2";

const inputClass =
	"w-full bg-transparent text-label1-bold text-trade-text outline-none placeholder:text-trade-text-faint sm:text-body2-bold";

const labelClass = "whitespace-nowrap text-label2 sm:text-body2";

export function TriggerPriceField() {
	const { t } = useTranslate();
	const [triggerPrice, setTriggerPrice] = useAtom(triggerPriceAtom);

	return (
		<label className={fieldClass}>
			<div className="flex w-full items-center gap-2">
				<p className={labelClass}>{t("form.trigger")}</p>
				<input
					type="text"
					inputMode="decimal"
					className={inputClass}
					value={triggerPrice}
					onChange={(e) =>
						setTriggerPrice(
							sanitizeNumericInput(e.target.value, PRICE_MAX_DECIMALS),
						)
					}
					placeholder="0"
				/>
			</div>
			<p className={labelClass}>USDC</p>
		</label>
	);
}
